import {HTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {useFormControlContext} from '@/components/form/form-control/form-control';

const AssistiveText = ({className, children, ...props}: HTMLAttributes<HTMLDivElement>) => {
  const {isInError, hasWarning} = useFormControlContext();

  const mergedClasses = twMerge(
    clsx(
      'text-sm text-charcoal transition-colors peer-focus:text-violet',
      className,
      isInError && 'text-red',
      hasWarning && 'text-yellow-600',
    ),
  );

  return (
    <div className="ml-4 min-h-6">
      {children && (
        <div className={mergedClasses} {...props}>
          {children}
        </div>
      )}
    </div>
  );
};

export default AssistiveText;
